module.exports = __webpack_public_path__ + "img/KoN_smoke.bd80268f.png";